import React from 'react';

//Componentes auxiliares materialui:
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Route, Switch } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

//Rutas del layout:
import authMenuRoutes from './menuRoutes/authMenuRoutes';

const logoAlt = process.env.REACT_APP_CRAWLER_OWNER + " Crawler";
const ownerLogo = "/owner-logos/" + process.env.REACT_APP_CRAWLER_OWNER + ".png"
// const ownerLogo = "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/5c74e4af400dae184dfa518f8e54c7a0";

const backgroundImages = [
    'https://images.unsplash.com/photo-1573164574511-73c773193279?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2550&q=80',
    'https://images.unsplash.com/photo-1588091210060-1ee4fab270ae?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1244&q=80',
    'https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2255&q=80',
    'https://images.unsplash.com/photo-1533749871411-5e21e14bcc7d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2251&q=80',
    'https://images.unsplash.com/photo-1573166364839-1bfe9196c23e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80'
]

const useStyles = makeStyles(theme => {
    return ({
        root: {
            height: '100vh',
        },
        image: {
            backgroundImage: 'url(' + backgroundImages[Math.floor(Math.random() * backgroundImages.length)] + ')',
            backgroundRepeat: 'no-repeat',
            backgroundColor:
                theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        },
        paper: {
            margin: theme.spacing(8, 4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1),
        },
        submit: {
            margin: theme.spacing(3, 0, 2),
        },
    });
});

const customFontStyle = {
    fontFamily: '"Montserrat", "Helvetica Neue", Arial, sans-serif'
};

let AuthLayout = (props) => {

    const classes = useStyles();
    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>

                <div className={classes.paper}>
                    <img style={{ height: 100, marginBottom: 25 }} alt={logoAlt} src={ownerLogo} />

                    <h5 style={{ ...customFontStyle }}>
                        <b>{process.env.REACT_APP_CRAWLER_OWNER}</b> Crawler
                    </h5>

                    <Switch>
                        {authMenuRoutes.map((route, key) => {
                            return (
                                <Route path={route.layout + route.path} key={key}
                                    render={(props) => <route.component {...props}
                                        classes={classes} customFontStyle={customFontStyle} />} />
                            );
                        })}
                    </Switch>

                    <Box mt={5}>
                        <Copyright />
                    </Box>
                </div>
            </Grid>
        </Grid>
    );
}

let Copyright = () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{ fontSize: 10 }}>
            {'Copyright © '}
            <b>{process.env.REACT_APP_CRAWLER_OWNER}</b>
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default AuthLayout;